/**
 * 标注一个组件为一个页面组件
 *
 * @file page.js
 * @author zhanghao25@baidu.com
 */

import {router} from 'san-router';

export default (...rules) => Klass => {

    rules.forEach(
        rule => router.add({
            rule,
            Component: Klass,
            target: '#main'
        })
    );

    return Klass;
};
